import { MapMarkerAlertOutlineIcon } from './MapMarkerAlertOutlineIcon';

/**
 * author: François Risoud
 * id 65B4F317-EB12-4BD4-8E9B-C6D3A153B868
 * name map-marker-alert-outline
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-alert-outline.svg
 * tags
 * - Navigation 
 * - Alert / Error 
 * - Geographic Information System 
 */
export const LocationAlertOutlineIcon = MapMarkerAlertOutlineIcon;
export default LocationAlertOutlineIcon